<template>
    <div class="gs-checkout-popup-note">
        <div>
            <strong>Use a GroovePages popup</strong>
            <p>
                {{ $t('frontend_groovesell_link_checkout_popup_modal_text', {pagesAppTitle: whitelabelAppData('pages').title}) }}
            </p>
        </div>
    </div>
</template>
<script>
export default {

}
</script>

<style scoped>
.gs-checkout-popup-note {
    padding: 16px;
    color: #315d8a;
    background: #eef7ff;
    border: 1px solid #cee7ff;
    border-radius: 10px;
}

.gs-checkout-popup-note strong {
    font-size: 12px;
    font-weight: 800;
}

.gs-checkout-popup-note p {
    margin: 5px 0 0;
    font-size: 11px;
    line-height: 1.55;
}
</style>
